
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/** ---------------- TYPES ---------------- */

// Generic key-value store
type ReduxDataMap = Record<string, unknown>;

// Modal state map
type ModalMap = Record<string, boolean>;

// Pagination type
interface PaginationType {
  pageSize: number | string | undefined;
  pageIndex: number;
}

// Main state interface
interface ReduxStateData {
  reduxData: ReduxDataMap;
  isModalOpen: boolean;

  modals: ModalMap;
  filterData: unknown[];
  currentActiveTab: string;
  exportFilterData: unknown[];
  tableData: unknown[];
  pagination: PaginationType;



}

/** ---------------- INITIAL STATE ---------------- */
const defaultPageSize = Number(import.meta.env.VITE_TABLE_PAGE ?? 10);

const initialState: ReduxStateData = {
  reduxData: {},
 
  isModalOpen: false,
  modals: {},
  currentActiveTab: "Plan",
  filterData: [],
  exportFilterData: [],
  tableData: [],
  pagination: {
    pageSize: Number.isFinite(defaultPageSize) && defaultPageSize > 0 ? defaultPageSize : 10,
    pageIndex: 1,
  },

  

};

/** ---------------- SLICE ---------------- */

const reduxDataSlice = createSlice({
  name: "reduxData",
  initialState,
  reducers: {
    reduxSliceData: (
      state,
      action: PayloadAction<{ key: string; data: unknown }>
    ) => {
      state.reduxData[action.payload.key] = action.payload.data;
    },

    reduxSliceDataClear: (
      state,
      action: PayloadAction<{ key: string }>
    ) => {
      state.reduxData[action.payload.key] = [];
    },

    clearAll: () => initialState,

    openModal: (state) => {
      state.isModalOpen = true;
    },

    closeModal: (state) => {
      state.isModalOpen = false;
    },



    setFilterData: (state, action: PayloadAction<unknown[]>) => {
      state.filterData = action.payload;
    },

    setPagination: (state, action: PayloadAction<PaginationType>) => {
      state.pagination = action.payload;
    },

    setCurrentActiveTab: (state, action: PayloadAction<string>) => {
      state.currentActiveTab = action.payload;
    },

    setExportFilterData: (state, action: PayloadAction<unknown[]>) => {
      state.exportFilterData = action.payload;
    },

    setTableData: (state, action: PayloadAction<unknown[]>) => {
      state.tableData = action.payload;
    },

    addOpenModal: (state, action: PayloadAction<string>) => {
      state.modals[action.payload] = true;
    },

    addCloseModal: (state, action: PayloadAction<string>) => {
      state.modals[action.payload] = false;
    },

   

  
  },
});

/** ---------------- EXPORTS ---------------- */

export const {
  reduxSliceData,
  reduxSliceDataClear,
  clearAll,
  openModal,
  closeModal,
  addOpenModal,
  addCloseModal,
  setFilterData,
  setExportFilterData,
  setTableData,
  setPagination,
  setCurrentActiveTab,

} = reduxDataSlice.actions;

export default reduxDataSlice.reducer;